import {type Table} from 'notebook/tables/constants/TableConstants';
import {MultiSelectionBox} from 'notebook/tables/constants/TableSelectionConstants';
import excess from 'notebook/tables/excess';
import {type EvaluatedCell} from 'notebook/tables/excess/EvaluationConstants';
import {type TableOpDiff} from 'notebook/tables/excess/ops/TableOpConstants';

/** The result of a fill-down mutation. */
export interface FillDownResult {
  /** The new table with the filled-down cells applied. */
  table: Table;
  /** The region that was filled into, as {minI, maxI, minJ, maxJ}. */
  box: MultiSelectionBox;
  /** The table op describing the change, for persistence / undo. */
  tableOp: TableOpDiff;
}

/**
 * Fill-down the `srcBox` region across the `dstBox` region of the table.
 *
 * @param table - The table to modify.
 * @param computedTable - The evaluated cells of the table (results of formulas).
 * @param srcBox - The source selection to tile / extrapolate from.
 * @param dstBox - The destination region to fill into. Must match `srcBox` in at
 *   least one dimension.
 * @param disableFormulas - Whether formulas are disabled for this table.
 */
export function fillDown(
  table: Table,
  computedTable: Array<Array<EvaluatedCell>>,
  srcBox: MultiSelectionBox,
  dstBox: MultiSelectionBox | null | undefined,
  disableFormulas: boolean
): FillDownResult {
  return excess.ops.fillDown(table, computedTable, srcBox, dstBox, disableFormulas);
}
